import { LABELS } from "./constants";

// I want to move these functions and their related types to the decoders or near where we get this
// data and instantitate it with the Carrosserievorm type but that doesn't exist yet so I'm putting
// it here for now

export const CARROSSERIEVORM_VALUES = [
    "BEDRIJFSWAGEN",
    "CABRIOLET",
    "CAMPER",
    "COUPE",
    "HATCHBACK",
    "MPV",
    "OVERIG",
    "PERSONENBUS",
    "PICK_UP",
    "SEDAN",
    "STATIONWAGEN",
    "SUV"
] as const;

export type Carrosserievorm = typeof CARROSSERIEVORM_VALUES[number];

export const isCarrosserievorm = (x: string): x is Carrosserievorm =>
    CARROSSERIEVORM_VALUES.some((y) => x === y);

export const labelFromCarrosserievorm = (x: string): string | undefined => {
    switch (x) {
        case "BEDRIJFSWAGEN":
        case "CABRIOLET":
        case "CAMPER":
        case "COUPE":
        case "HATCHBACK":
        case "MPV":
        case "PERSONENBUS":
        case "PICK_UP":
        case "SEDAN":
        case "STATIONWAGEN":
        case "SUV":
            return LABELS.BODY_TYPE[x];

        default:
            return undefined;
    }
};

export const getCarrosserievormFromSlug = (x: string): Carrosserievorm => {
    switch (x) {
        case "hatchback":
            return "HATCHBACK";

        case "stationwagen":
            return "STATIONWAGEN";

        case "mpv":
            return "MPV";

        case "sedan":
            return "SEDAN";

        case "suv":
            return "SUV";

        case "bedrijfswagen":
            return "BEDRIJFSWAGEN";

        case "cabriolet":
            return "CABRIOLET";

        case "coupe":
            return "COUPE";

        case "personenbus":
            return "PERSONENBUS";

        case "pick-up":
            return "PICK_UP";

        case "camper":
            return "CAMPER";

        default:
            return "OVERIG";
    }
};
